module.exports = __webpack_public_path__ + "img/JUNTOS.ee7d4c67.png";